<div class="theme-customizer">
  <div class="theme-customizer__header">
    <h2>Theme Customizer</h2>
    <div class="theme-customizer__actions">
      <button (click)="resetTheme()" class="btn-reset">Reset Theme</button>
      <button (click)="exportTheme()" class="btn-export">Export Theme</button>
      <input 
        type="file" 
        accept=".json" 
        (change)="importTheme($event)" 
        class="file-input" 
        id="themeImport"
      >
      <label for="themeImport" class="btn-import">Import Theme</label>
    </div>
  </div>

  <div class="theme-customizer__content">
    <ng-container *ngFor="let category of categories$ | async">
      <div class="category">
        <h3 class="category__title">{{ category.name }}</h3>
        <div class="category__variables">
          <div 
            *ngFor="let variable of category.variables" 
            class="variable-control"
          >
            <label [for]="variable.name" class="variable-control__label">
              {{ variable.name }}
            </label>
            
            <ng-container [ngSwitch]="variable.type">
              <!-- Color Input -->
              <div *ngSwitchCase="'color'" class="variable-control__input-group">
                <input 
                  [id]="variable.name"
                  type="color" 
                  [value]="variable.value"
                  (input)="updateVariable(variable, $event)"
                  class="variable-control__color-input"
                >
                <input 
                  type="text" 
                  [value]="variable.value"
                  (input)="updateVariable(variable, $event)"
                  class="variable-control__text-input"
                >
              </div>

              <!-- Font Input -->
              <div *ngSwitchCase="'font'" class="variable-control__font-selector">
                <!-- Search input for fonts -->
                <!-- <input 
                  type="text" 
                  [(ngModel)]="searchTerm"
                  placeholder="Search fonts..."
                  class="variable-control__search-input"
                > -->
                
                <!-- Font selection -->
                <div class="font-list">
                  <!-- System fonts -->
                  <div class="font-group">
                    <h4 class="font-group__title">System Fonts</h4>
                    <div class="font-option" 
                         *ngFor="let font of ['Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Courier New', 'Verdana']"
                         [style.fontFamily]="font"
                         (click)="selectFont(variable, font)">
                      <span class="font-preview">{{ font }}</span>
                    </div>
                  </div>

                  <!-- Google Fonts -->
                  <div class="font-group">
                    <h4 class="font-group__title">Google Fonts</h4>
                    <div class="font-option" 
                         *ngFor="let font of filterFonts(googleFonts$ | async, searchTerm)"
                         [style.fontFamily]="font.family"
                         (click)="selectFont(variable, font.family)">
                      <span class="font-preview">{{ font.family }}</span>
                      <span class="font-category">{{ font.category }}</span>
                    </div>
                  </div>
                </div>

                <!-- Current font preview -->
                <div class="font-preview-box" [style.fontFamily]="variable.value">
                  <span class="preview-text">The quick brown fox jumps over the lazy dog</span>
                  <span class="current-font">Current: {{ variable.value }}</span>
                </div>
              </div>

              <!-- Default Text Input -->
              <input 
                *ngSwitchDefault
                [id]="variable.name"
                type="text" 
                [value]="variable.value"
                (input)="updateVariable(variable, $event)"
                class="variable-control__text-input"
              >
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Preview Section -->
  <!-- <div class="theme-preview">
    <h3>Preview</h3>
    <div class="preview-content">
      <button class="btn-primary">Primary Button</button>
      <button class="btn-secondary">Secondary Button</button>
      <div class="card">
        <h4>Sample Card</h4>
        <p>This is a preview of how your theme looks on various components.</p>
        <input type="text" placeholder="Sample Input" class="preview-input">
      </div>
    </div>
  </div> -->
</div>